import { render, staticRenderFns } from "./DialogScopeCustomer.vue?vue&type=template&id=c7312394&scoped=true"
import script from "./DialogScopeCustomer.vue?vue&type=script&lang=js"
export * from "./DialogScopeCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7312394",
  null
  
)

export default component.exports